<div class="h-svh flex flex-col">
  <header class="flex flex-row mt-6 mb-6">
    <img
      (click)="goBack()"
      [class.hidden]="!shouldDisplayBackButton()"
      class="w-6 h-6 cursor-pointer"
      src="./../../../../../assets/images/svg/go-back-arrow.svg"
    />
    <h1 class="m-auto font-bold text-secondary text-sm">{{ title | translate }}</h1>
    <!-- Trick to center header title -->
    <div class="w-6 h-6"></div>
  </header>

  <div class="flex flex-1">
    @switch (processPage()) {
      @case ('CONSENT') {
        <app-consent class="w-full"></app-consent>
      }
      @case ('BANK_CHOICE') {
        <app-bank-choice class="w-full"></app-bank-choice>
      }
      @case ('SELECT_REGIONAL_BANK') {
        <app-select-regional-bank class="w-full"></app-select-regional-bank>
      }
      @case ('WAIT_ON_EXTERNAL_BANK_LOGIN') {
        <app-wait-on-external-bank-login class="w-full"></app-wait-on-external-bank-login>
      }
      @case ('BANK_CONNECTION_FAILURE_RETRY') {
        <app-bank-connection-failure-retry class="w-full"></app-bank-connection-failure-retry>
      }
      @case ('SELECT_ACCOUNTS') {
        <app-select-accounts class="w-full"></app-select-accounts>
      }
      @case ('NONE_ACCOUNTS') {
        <app-none-accounts-found class="w-full"></app-none-accounts-found>
      }
      @case ('ACCOUNTS_ANALYSIS') {
        <app-accounts-connection class="w-full"></app-accounts-connection>
      }
      @case ('LOADING') {
        <app-loading class="w-full"></app-loading>
      }
    }
  </div>
</div>
